import {AfterContentInit, Component, ContentChildren, ElementRef, QueryList, ViewChildren} from '@angular/core';
import {TabsService} from "../../../services/tabsService";
import {MapService} from "../../../services/map.service";
import {GritApiService} from "../../../services/grit/grit.api.service";
import {CoordenateService} from "../../../services/coordenate.service";
import {PointsService} from "../../../services/points.service";
import {ModalConfirmationService} from "../../../services/modal-confirmation.service";
import {UiBlockService} from "../../../services/ui-block.service";
import {ModalControlService} from "../../../services/modal-control.service";
import {GritInterferenceTestService} from "../../../services/grit/grit.interference-test.service";
import VectorSource from "ol/source/Vector";
import {Draw} from "ol/interaction";
import Geometry from "ol/geom/Geometry";
import olMap from "ol/Map";
import Circle from "ol/geom/Circle";
import GeoJSON from "ol/format/GeoJSON";
import {Feature} from "ol";
import Polygon, {fromCircle} from "ol/geom/Polygon";
import {InterferenceTestModel} from "../../../models/grit/grit.interference-test-model";
import {GritCondition, GritConditionType, GritFilter} from "../../../models/grit/grit.filter";
import {GritProjectService} from "../../../services/grit/grit.project.service";
import {FilterMode, GritFeatureFilterService} from "../../../services/grit/grit.feature-filter.service";
import {FeatureType} from "../../../models/EnumTypes";
import {GritFeature} from "../../../models/grit/grit.feature";
import {DeviceSectorization, InterferenceTestDeviceModel} from "../../../models/grit/grit.device-model";
import {InterferenceTestModelStates} from "../../../models/grit/grit.enums";
import {CalculationsService} from "../../../services/calculations.service";
import {UserSettingsService} from "../../../services/userSettings.service";
import {CalcImpactAssessmentLog} from "../../../models/calcConfigInfo";
import {GritUserRoleGroup, GritUserService} from "../../../services/grit/grit.user.service";
import {TopLevelLayers} from "../../../menu/view-menu/top-level-layers";
import {DeviceCalculationDTO, ImpactAssessmentDTO} from "../../../models/grit/grit.calculation-dto";
import {features} from "process";
import * as olExtent from "ol/extent";
import {Coordinate} from "ol/coordinate";
import Point from "ol/geom/Point";
import LineString from "ol/geom/LineString";
import {coordinate} from "../../../models/coordinate";
import {Sectorization} from "../../../models/sectorization";
import {NOTAM, notamEntity} from "../../../models/grit/grit.notam";
import {lastValueFrom} from "rxjs";
import {ConfigurationModel} from "../../../models/configuration";
import {GritUtils} from "../../../utils/grit/GritUtils";
import {clone, cloneDeep} from "lodash";
import {NotamType} from "../../../utils/grit/grit-notam/grit-notam.component";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {AddDeviceSectorizationComponent} from "../../../popup/grit/add-device-sectorization/add-device-sectorization.component";
import {SendNotamComponent} from "../../../popup/grit/send-notam/send-notam.component";
import {fromLonLat} from "ol/proj";
import {getLength} from "ol/sphere";
import { GritGroupsComponent } from 'src/app/utils/grit/grit-groups/grit-groups.component';

@Component({
  selector: 'app-interference-test',
  templateUrl: './interference-test.component.html',
  styleUrls: ['../../../app.component.scss','./interference-test.component.scss'],
  standalone: false
})
export class InterferenceTestComponent {
  protected readonly InterferenceTestModel = InterferenceTestModel;

  map: olMap;
  drawArea : Draw;

  selected_stakeholder : { i:number, email:string } = null;
  
  readonly groupsNotNull = GritGroupsComponent.groupsNotNull;

  constructor(public interferenceTestService: GritInterferenceTestService,
              public tabsService: TabsService,
              private mapService: MapService,
              private gritAPIService: GritApiService,
              private rcsControl: CoordenateService,
              protected pointsService: PointsService,
              protected popupService : BsModalService,
              private modalConfirmation: ModalConfirmationService,
              private uiBlock: UiBlockService,
              protected modalService: ModalControlService,
              private projectService : GritProjectService,
              private featureFilterService : GritFeatureFilterService,
              private calculationsService : CalculationsService,
              private userSettingsService : UserSettingsService,
              protected gritUserService : GritUserService,
  ) {
    this.map = mapService.getMap('map');
  }

  getCalculations() : TopLevelLayers[]{
    return this.pointsService.calculationsLayers.childLayers.filter(layer => layer.calcID != -1);
  }

  async focus(){
    if (this.interferenceTestService.focusPublicInterferenceTest != null ||
      this.interferenceTestService.projectInterferenceTest?.id == this.interferenceTestService.detailsTab.selected.id){
      this.interferenceTestService.focus(true);
      return;
    }

    this.uiBlock.startBlock("Getting Interference Test")
    let interferenceTest = this.interferenceTestService.detailsTab.selected;

    let entities = await this.gritAPIService.interferenceTestGetEntities(interferenceTest.id);

    if (entities == null){
      this.modalService.showMesssageModal('Error Getting Interference Test Entities', "Unable to get entities");
      this.uiBlock.stopBlock()
    }

    this.pointsService.addDevicesToMap(entities.devices);

    let calculation = await this.calculationsService.getCalculationById(interferenceTest.calculationId);
    calculation.id = -1;
    this.calculationsService.addCalculationsToMap([calculation]);

    let filter = new GritFilter();
    filter.conditions.push([new GritCondition("id", GritConditionType.Equal, interferenceTest.id)])
    this.featureFilterService.applyFilter(FeatureType.InterferenceTest, [filter], FilterMode.ONLY,
      (feature: GritFeature<InterferenceTestModel>, mode : FilterMode, result: boolean) => {
        if(mode == FilterMode.ONLY && !result) {
          this.pointsService.tabsService.removeInterferenceTestTabById(feature.entity.id);
        }

        return false;
      })

    this.interferenceTestService.focusPublicInterferenceTest = interferenceTest
    this.interferenceTestService.focus(true);

    this.uiBlock.stopBlock()
  }

  activateTab(n: number) {
    this.interferenceTestService.detailsTab.tab = n;
  }

  async saveRoutine(verbose: boolean = true): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      let interferenceTestUpdated = this.interferenceTestService.detailsTab.selected;

      return this.gritAPIService.interferenceTestUpdate(interferenceTestUpdated).then(
        (interferenceTest) => {
          if (verbose)
            this.modalService.showMesssageModal(
              "Interference Test Saved",
              "The Interference Test was edited sucessfully!");

          let features = this.pointsService.getGritFeatures<InterferenceTestDeviceModel>(FeatureType.Device)

          if (interferenceTest?.deviceMaskRadius !== interferenceTestUpdated.deviceMaskRadiusOriginal){
            let projection = this.mapService.getMaps().getView().getProjection();

            interferenceTestUpdated.deviceMaskRadiusOriginal = interferenceTest.deviceMaskRadius;

            if (interferenceTest.deviceMaskRadius > 0){
              this.uiBlock.startBlock("Masking Devices Locations...");

            }else if (interferenceTest.deviceMaskRadius == 0){
              this.uiBlock.startBlock("Removing Devices Masking Locations...");
            }

            let radius = interferenceTest.deviceMaskRadius * 1000; //km to m
            let devicesUpdate = features.map(feature => {
              feature.entity.defineHiddenArea(radius, projection);
              return feature.entity
            })

            this.gritAPIService.itDeviceUpdate(devicesUpdate).then(
              (devices) => {
                if (verbose)
                  this.modalService.showMesssageModal(
                    "Devices Mask Update",
                    "The devices mask was changed.");

                this.pointsService.addDevicesToMap(devices);
                resolve(true)
              },
              (response) => {
                let message: string = '';
                response['error']['errors'].map(error => message += `${error['message']};\n`);
                this.modalService.showMesssageModal('Error Saving RFI-Transmitter', message);
                resolve(false);
              }
            ).finally(() => this.uiBlock.stopBlock());
          }
          else{
            resolve(true);
          }
        },
        (response) => {
          let message: string = '';
          response['error']['errors'].map(error => message += `${error['message']};\n`);
          this.modalService.showMesssageModal('Error Saving Interference Test', message);
          resolve(false);
        }
      )
    })
  }

  save() {
    this.modalConfirmation.showMesssageConfirmationModal(
      "Save Interference Test",
      "Do you wish to continue and save the changes?",
      "OK", "Cancel",
      async () => {
        this.uiBlock.startBlock("Saving Interference Test...")

        await this.saveRoutine()

        this.uiBlock.stopBlock()
      },
      () => this.interferenceTestService.resetProjetInterferenceTest()
    );
  }

  saveNOTAM(type: string){
    let id = this.interferenceTestService.detailsTab.selected.id;
    let notam = type == "accept" ?
      JSON.stringify(this.interferenceTestService.detailsTab.selected.notamAccept) :
      JSON.stringify(this.interferenceTestService.detailsTab.selected.notamCancel);

    this.uiBlock.startBlock("Saving Notam...")

    return this.gritAPIService.interferenceTestUpdateNOTAM(id, type, notam).then(
      (notam) => {},
      (response) => {
        let message: string = '';
        response['error']['errors'].map(error => message += `${error['message']};\n`);
        this.modalService.showMesssageModal('Error Saving NOTAM', message);

      }
    ).finally(() => this.uiBlock.stopBlock())
  }

  sendNOTAM(notam: NOTAM){
    const bsModalRef : BsModalRef = this.popupService.show(SendNotamComponent);
    bsModalRef.content.notam = notam;
  }

  defineTestArea(type: any) : void{
    if(this.drawArea != null){
      this.map.removeInteraction(this.drawArea);
      if (type == this.drawArea.get("type")){
        this.drawArea = null;
        return;
      }
    }

    const source = new VectorSource();
    this.drawArea = new Draw({
      source: source,
      type: type,
    });
    this.drawArea.set("type", type);
    this.map.addInteraction(this.drawArea);

    let context = this;
    this.drawArea.on('drawend', async function (endEvent) {
      context.map.removeInteraction(context.drawArea);
      context.drawArea = null;

      let feature : Feature<Geometry> = endEvent.feature;
      if (type == "Circle"){
        let geometry = feature.getGeometry() as Circle;
        feature.setGeometry(fromCircle(new Circle(geometry.getCenter(), geometry.getRadius()), 64));
      }

      context.interferenceTestService.detailsTab.selected.testArea = new GeoJSON().writeGeometry(feature.getGeometry(), {
        dataProjection: 'CRS:84',
        featureProjection: context.rcsControl.activeRCS.isactive? context.rcsControl.activeRCS.epsg : "EPSG:3857"
      })

      //TODO Change to submit
      context.interferenceTestService.detailsTab.selected.firs = await context.projectService.getFir(feature.getGeometry())

      context.pointsService.addProjectInterferenceTestToMap(context.interferenceTestService.detailsTab.selected);

      context.interferenceTestService.focus();
    });
  }

  loadMailingList(i: number){
    let interferenceTest = this.interferenceTestService.projectInterferenceTest;
    let list = this.gritUserService.profile.mailingList[i];

    list?.list.forEach(entry =>{
      let i = interferenceTest.stakeholders.indexOf(entry.email);
      if (i == -1) interferenceTest.stakeholders.push(entry.email);
    });
  }

  addStakeholder(email : string){
    this.interferenceTestService.projectInterferenceTest.stakeholders.push(email);
  }

  editStakeholder(i : number){
    let interferenceTest = this.interferenceTestService.projectInterferenceTest;


    if (this.selected_stakeholder?.i == i){
      if (GritUserService.validateEmail(this.selected_stakeholder.email)){
        interferenceTest.stakeholders[i] = this.selected_stakeholder.email;
      }
      this.selected_stakeholder = null;
      return;
    }

    this.selected_stakeholder = {
      i: i,
      email: interferenceTest.stakeholders[i],
    }
  }

  deleteStakeholder(i : number){
    this.interferenceTestService.projectInterferenceTest.stakeholders.splice(i, 1);
  }

  async clearCalculationAndDevices(): Promise<boolean>{
    return await new Promise(async (resolve, reject) => {
      let interferenceTest = this.interferenceTestService.detailsTab.selected;

      let calcInfo = JSON.parse((await this.calculationsService.getCalcInfo(interferenceTest.calculationId)).calcConfig) as CalcImpactAssessmentLog;
      let usedDevicesId = calcInfo.calculationImpactAssessmentDTO.devices.map(device => Number(device.id.split("-").at(0))); //TODO

      let calculationsToDelete = this.pointsService.calculationsLayers.childLayers
        .filter(child => child.type == 'Impact Assessment' && child.calcID != interferenceTest.calculationId)
        .map(child => child.calcID);

      let devicesFeaturesToDelete = this.pointsService.getGritFeatures<InterferenceTestDeviceModel>(FeatureType.Device)
        .filter(feature => !usedDevicesId.includes(feature.entity.id))

      this.calculationsService.deleteBulKCalculation(calculationsToDelete).subscribe({
        next: (data) => {
          calculationsToDelete.forEach( id =>{
            this.calculationsService.removeLayers(id);
          });
          this.userSettingsService.deleteCalculationsSettings(calculationsToDelete);
          this.tabsService.deleteCalculationTabs(calculationsToDelete);
          this.uiBlock.stopBlock();

          //Devices
          if (devicesFeaturesToDelete.length == 0){
            resolve(true);
            return;
          }

          this.uiBlock.startBlock("Deleting devices...")
          return this.gritAPIService.itDeviceDelete(devicesFeaturesToDelete.map(feature => feature.entity)).then(
            (devices) => {
              this.pointsService.removeGritFeaturesFromMap(devicesFeaturesToDelete)
              this.uiBlock.stopBlock()
              resolve(true)
            },
            (error) => {
              this.modalService.showMesssageModal("Devices Delete", "Error deleting the selected devices.")
              this.uiBlock.stopBlock()
              resolve(false);
            }
          )
        },
        error: (error) => {
          this.calculationsService.showError(error);
          this.uiBlock.stopBlock();
          resolve(false);
        }
      })
    })
  }

  trigger(trigger: string, save: boolean = true){
    this.modalConfirmation.showMesssageConfirmationModal(
      trigger,
      "Are you sure you want to trigger this, non reversible, action?",
      "OK", "Cancel",
      async () => {
        this.uiBlock.startBlock("Changing State...")

        if (save && !await this.saveRoutine(false)){
          this.modalService.showMesssageModal(
            'Error Saving Interference Test',
            'Failure saving changes for state change.'
          );
          this.uiBlock.stopBlock()
          return;
        }

        if((trigger == "Submit" || trigger == "Approve")){
          if(this.interferenceTestService.projectInterferenceTest.calculationId == 0 || !await this.clearCalculationAndDevices()){
            return;
          }
        }

        this.gritAPIService.interferenceTestTrigger(trigger).then(
          async (InterferenceTestModel) => {
            await this.interferenceTestService.resetProjetInterferenceTest(InterferenceTestModel);

            if(trigger == "Approve"){
              await this.generateAcceptNOTAM();
            }
            else if(trigger == "Cancel"){
              await this.generateCancellationNOTAM();
            }

          }
        ).finally(() => this.uiBlock.stopBlock())
      },
      () => this.interferenceTestService.resetProjetInterferenceTest()
    );
  }

  async generateAcceptNOTAM(){
    this.uiBlock.startBlock("Generating Approval NOTAM")

    try{
      let interferenceTest = this.interferenceTestService.projectInterferenceTest;

      let calcConfigInfo = JSON.parse(
        (await this.calculationsService.getCalcInfo(interferenceTest.calculationId)).calcConfig) as CalcImpactAssessmentLog;

      //NOTAM Fill
      let originState  = interferenceTest.groupOriginator
        .split(/^\/([a-z.-_][^\/]+)\/.*$/i).filter(el => el != "").at(0) ?? null;

      let   icaoOriginState = GritProjectService.globalInformation.countries
        .find(opt => opt.display.match(new RegExp(originState,"i")))?.value ?? null

      //Process devices into a reduced format
      let unifiedEntity : notamEntity = {
        id : 0,
        coordinate: [0,0],
        height: 0,
        range: 0,
        sectorizations : []
      }
      let devices : notamEntity[] = [];

      //#region Process devices into notamEntities
      calcConfigInfo.calculationImpactAssessmentDTO.devices.forEach((deviceCalc : DeviceCalculationDTO) => {
        let types = deviceCalc.type.split("-");
        if (!types[0].startsWith(types[1])) return; //Device type and Receiver Device type are different

        let id = deviceCalc.id.split("-").at(0);
        let device = devices.find(entity => entity.id == id);

        //If it already exists, check if new range is higher
        if (device != undefined){
          if (device.range < deviceCalc.range){
            device.range = deviceCalc.range;
            device.sectorizations = deviceCalc.sectorizations;
          }
          return;
        }

        let entity : notamEntity = {
          id : id,
          coordinate: [deviceCalc.longitude, deviceCalc.latitude],
          height: deviceCalc.effectiveHeight,
          range: deviceCalc.range,
          sectorizations : deviceCalc.sectorizations
        };
        // entity.sectorizations?.forEach(sect =>{if (sect.doc > entity.range) entity.range = sect.doc})

        //If it's masked, change values
        if (deviceCalc.maskLatitude != null && deviceCalc.maskLongitude != null){
          let maskCenter = [deviceCalc.maskLongitude, deviceCalc.maskLatitude];

          let distance = GritUtils.distanceBetween(entity.coordinate, maskCenter);

          entity.coordinate = maskCenter;
          entity.range += ConfigurationModel.metersToNm(distance);
        }

        devices.push(entity);
      });
      //#endregion

      //#region Unify the notam entities
      if (devices.length == 0){
        interferenceTest.notamAccept = new NOTAM();
        return;
      }
      else if (devices.length == 1){
        unifiedEntity = devices[0];
      }
      else {
        if (devices.length == 2){
          unifiedEntity.coordinate = new LineString([devices[0].coordinate, devices[1].coordinate]).getCoordinateAt(0.5)
        }
        else{
          let coordinates = devices.map(entity => entity.coordinate);
          unifiedEntity.coordinate = olExtent.getCenter(new Polygon([coordinates]).getExtent())
        }

        for (let device of devices){
          let distance = GritUtils.distanceBetween(unifiedEntity.coordinate, device.coordinate);

          let dRange = device.range
          device.sectorizations.forEach(sect => {if (dRange < sect.doc) dRange = sect.doc})

          let range = ConfigurationModel.metersToNm(distance) + dRange;
          //range is NM
          if (unifiedEntity.range < range) unifiedEntity.range = range;
        }
      }
      //#endregion

      unifiedEntity.height = ConfigurationModel.metersToFeet(await this.pointsService.gritGetTerrainElevation(unifiedEntity.coordinate));
      unifiedEntity.dateStart = interferenceTest.dateStart;
      unifiedEntity.dateEnd = interferenceTest.dateEnd;
      unifiedEntity.firs = interferenceTest.firs;

      interferenceTest.notamAccept = NOTAM.generateNotam(icaoOriginState, interferenceTest.type, interferenceTest.areaType, unifiedEntity)

      await this.saveNOTAM("accept")
    }
    catch (error){
      console.error("Error generating notam:", error)
    }

    this.uiBlock.stopBlock();
  }

  async generateCancellationNOTAM(){
    this.uiBlock.startBlock("Generating Cancellation NOTAM")

    try {
      let interferenceTest = this.interferenceTestService.projectInterferenceTest;

      interferenceTest.notamCancel = cloneDeep(interferenceTest.notamAccept);

      interferenceTest.notamCancel.itemQ.notam_code = interferenceTest.notamCancel.itemQ.notam_code.substring(0, 3) + "CN"
      interferenceTest.notamCancel.itemB.datetime = new Date().getTime();
      interferenceTest.notamCancel.itemC.datetime = -1;

      interferenceTest.notamCancel.itemE.initialText = "";
      interferenceTest.notamCancel.itemE.areaActivation = "";

      interferenceTest.notamCancel.itemE.area = interferenceTest.notamCancel.decodeNotamCode();

      await this.saveNOTAM("cancel")

    } catch (error){
      console.error("Error generating notam:", error)
    }

    this.uiBlock.stopBlock();
  }

  protected readonly InterferenceTestModelStates = InterferenceTestModelStates;
  protected readonly GritUserRoleGroup = GritUserRoleGroup;
  protected readonly NotamType = NotamType;
  protected readonly GritUserService = GritUserService;
  protected readonly Number = Number;
}


